/* One cloud field shared by the page background and card previews. */
(() => {
  const palette={shadow:[55,111,162],light:[90,169,212]};
  const vertex=`attribute vec2 position; varying vec2 uv;
    void main(){ uv=position*.5+.5; gl_Position=vec4(position,0.,1.); }`;
  const fragment=`
    #ifdef GL_FRAGMENT_PRECISION_HIGH
    precision highp float;
    #else
    precision mediump float;
    #endif
    varying vec2 uv; uniform vec2 resolution; uniform float clock;
    uniform vec3 smokeShadow; uniform vec3 smokeLight;
    float hash(vec2 p){ return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453); }
    float noise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);
      return mix(mix(hash(i),hash(i+vec2(1.,0.)),f.x),mix(hash(i+vec2(0.,1.)),hash(i+vec2(1.)),f.x),f.y);}
    float fbm(vec2 p){float v=0.,a=.5;mat2 turn=mat2(.8,-.6,.6,.8);
      for(int i=0;i<4;i++){v+=a*noise(p);p=turn*p*2.03+vec2(13.4,7.1);a*=.5;}return v;}
    void main(){
      vec2 p=uv*vec2(resolution.x/resolution.y,1.)*3.4;
      float t=clock*.12;
      vec2 drift=vec2(cos(t),sin(t))*.48;
      vec2 warp=vec2(fbm(p+drift),fbm(p+vec2(5.2,1.3)-drift));
      float cloud=fbm(p+warp*2.7+vec2(sin(t*.7)*.3,-t*.2));
      float wisps=fbm(p*1.9+warp*2.1-vec2(t*.08,t*.13));
      float density=smoothstep(.24,.79,cloud*.75+wisps*.25);
      float sides=.58+.42*abs(uv.x-.5)*2.;
      vec3 blue=mix(smokeShadow,smokeLight,wisps);
      float alpha=density*.48*sides;gl_FragColor=vec4(blue*alpha,alpha);
    }`;
  const mix=(a,b,t)=>a+(b-a)*t;
  const fract=x=>x-Math.floor(x);
  const hash=(x,y)=>fract(Math.sin(x*127.1+y*311.7)*43758.5453);
  function noise(x,y){const ix=Math.floor(x),iy=Math.floor(y);let fx=x-ix,fy=y-iy;fx=fx*fx*(3-2*fx);fy=fy*fy*(3-2*fy);return mix(mix(hash(ix,iy),hash(ix+1,iy),fx),mix(hash(ix,iy+1),hash(ix+1,iy+1),fx),fy);}
  function fbm(x,y){let value=0,gain=.5;for(let i=0;i<4;i++){value+=gain*noise(x,y);const nx=(.8*x+.6*y)*2.03+13.4;y=(-.6*x+.8*y)*2.03+7.1;x=nx;gain*=.5;}return value;}
  function sample(u,v,aspect,clock,rise=0,offset=0){
    const px=u*aspect*3.4+offset,py=(1-v)*3.4-clock*rise,t=clock*.12;
    const dx=Math.cos(t)*.48,dy=Math.sin(t)*.48;
    const wx=fbm(px+dx,py+dy),wy=fbm(px+5.2-dx,py+1.3-dy);
    const cloud=fbm(px+wx*2.7+Math.sin(t*.7)*.3,py+wy*2.7-t*.2);
    const wisps=fbm(px*1.9+wx*2.1-t*.08,py*1.9+wy*2.1-t*.13);
    let density=Math.max(0,Math.min(1,(cloud*.75+wisps*.25-.24)/.55));density*=density*(3-2*density);
    return [...palette.shadow.map((color,i)=>mix(color,palette.light[i],wisps)),density*.48*(.58+.42*Math.abs(u-.5)*2)];
  }
  window.BazaarSmokeField={palette,vertex,fragment,sample};
})();
